import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AvailableProjects from './pages/AvailableProjects';
import MyProjects from './pages/MyProjects';
import ProjectDetail from './pages/ProjectDetail';
import AdminProjects from './pages/AdminProjects';
import AdminChapters from './pages/AdminChapters';
import AdminUsers from './pages/AdminUsers';
import AdminInterests from './pages/AdminInterests';
import ExecutiveDashboard from './pages/dashboards/ExecutiveDashboard';
import ReportUpload from './pages/admin/ReportUpload';
import ManualProjectEntry from './pages/admin/ManualProjectEntry';
import ReportBuilder from './pages/admin/ReportBuilder';
import ManualProjectsDashboard from './pages/dashboards/ManualProjectsDashboard';
import ChapterKPIDashboard from './pages/dashboards/ChapterKPIDashboard';
import ChapterDetailKPI from './pages/dashboards/ChapterDetailKPI';
import PDFComparison from './pages/tools/PDFComparison';
import './App.css';

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Public routes */}
            <Route path="/projects" element={<AvailableProjects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/my-projects" 
              element={
                <PrivateRoute>
                  <MyProjects />
                </PrivateRoute>
              } 
            />
            
            {/* Admin routes */}
            <Route 
              path="/admin/projects" 
              element={
                <AdminRoute>
                  <AdminProjects />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/chapters" 
              element={
                <AdminRoute>
                  <AdminChapters />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/users" 
              element={
                <AdminRoute>
                  <AdminUsers />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/interests" 
              element={
                <AdminRoute>
                  <AdminInterests />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/reports/upload" 
              element={
                <AdminRoute>
                  <ReportUpload />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/manual-entry" 
              element={
                <AdminRoute>
                  <ManualProjectEntry />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/report-builder" 
              element={
                <AdminRoute>
                  <ReportBuilder />
                </AdminRoute>
              } 
            />
            
            {/* Dashboard routes */}
            <Route 
              path="/dashboards/executive" 
              element={
                <AdminRoute>
                  <ExecutiveDashboard />
                </AdminRoute>
              } 
            />
            <Route 
              path="/dashboards/manual-projects" 
              element={
                <AdminRoute>
                  <ManualProjectsDashboard />
                </AdminRoute>
              } 
            />
            <Route 
              path="/dashboards/chapters" 
              element={
                <AdminRoute>
                  <ChapterKPIDashboard />
                </AdminRoute>
              } 
            />
            <Route 
              path="/dashboards/chapter/:chapterName" 
              element={
                <AdminRoute>
                  <ChapterDetailKPI />
                </AdminRoute>
              } 
            />
            <Route 
  path="/tools/pdf-comparison" 
  element={
    <AdminRoute>
      <PDFComparison />
    </AdminRoute>
  } 
/>
            <Route path="/" element={<Navigate to="/projects" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
